import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { getOutflowBarChartOption } from "../chartConfigs";
const OverviewOutflowChart = ({ data }) => {
  const option = useMemo(() => getOutflowBarChartOption(data), [data]);
  return (
    <ReactECharts option={option} style={{ height: 300 }} notMerge lazyUpdate />
  );
};

export default OverviewOutflowChart;
